import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title id="Dollar">{props.title || 'Dollar'}</title>
      <g>
        <g>
          <path d="M255.3-.7c-141.5 0-256.2 114.7-256.2 256.2s114.7 256.2 256.2 256.2 256.2-114.7 256.2-256.2c.1-141.5-114.7-256.2-256.2-256.2zm0 478.3c-122.5 0-222.1-99.6-222.1-222.1s99.7-222.1 222.1-222.1 222.1 99.6 222.1 222.1-99.6 222.1-222.1 222.1zM323.6 170.1c9.4 0 17.1-7.7 17.1-17.1 0-9.4-7.7-17.1-17.1-17.1h-51.3v-17.1c0-9.4-7.7-17.1-17.1-17.1-9.4 0-17.1 7.7-17.1 17.1v17.1h-17.1c-20.6 0-51.3 13.6-51.3 51.3v34.2c0 37.6 30.6 51.3 51.3 51.3h17.1v68.3h-51.1c-9.4 0-17.1 7.7-17.1 17.1 0 9.4 7.7 17.1 17.1 17.1h51.3v17.1c0 9.4 7.7 17.1 17.1 17.1 9.4 0 17.1-7.7 17.1-17.1v-17.1h17.1c20.6 0 51.3-13.6 51.3-51.3v-34.2c0-37.6-30.6-51.3-51.3-51.3h-17.1v-68.3h51.1zm-85.4 68.3h-17.1c-7.7-.2-17.1-3.3-17.1-17.1v-34.2c0-13.7 9.4-16.9 17.1-17.1h17.1v68.4zm51.3 34.2c7.7.2 17.1 3.3 17.1 17.1v34.2c0 13.7-9.4 16.9-17.1 17.1h-17.1v-68.3l17.1-.1z" />
        </g>
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/dollar.js